<script setup>
import NavList from './NavList.vue'
import { useAssetDropOptions, useOrderDropOptions } from './hooks'
import { useUserStore } from '@/store/user'
import iconWallet from '@/assets/images/header/icon-wallet.svg'
import { useRegisterExtra } from '@/components/auth/useAuth'
import iconOrder from '@/assets/images/header/icon-order.svg'
import { useBackUrl } from '~/hooks'
// import iconOrder from '@/assets/images/header/icon-order.svg'

const user = useUserStore()
const router = useRouter()
const { init } = useRegisterExtra()
const localePath = useLocalePath()

function toAuth(path) {
  init()
  router.push(useBackUrl(localePath(path)))
}
</script>

<template>
  <div v-if="user.isLogin">
    <NavList :icon="iconWallet" class-name="h-10 !w-10 !px-2 max-md:hidden" :options="useAssetDropOptions()" />
    <NavList :icon="iconOrder" class-name="h-10 !w-10 !px-2 ms-2" :options="useOrderDropOptions()" />
  </div>
  <div v-else class="max-md:px-4">
    <button class="px-6 hover:!bg-transparent  max-md:px-3" @click="toAuth('/log-in')">
      {{ $t('登录') }}
    </button>
    <button class="inline-flex items-center h-[32px] px-6  rounded-[100px] bg-themeNormal  max-md:px-3" @click="toAuth('/sign-up')">
      {{ $t('注册') }}
    </button>
  </div>
</template>
